import { handleActions } from 'redux-actions';
import { openHelpDialog, closeDialog } from './actions';

const defaultState = {
  currentOpenDialog: null
};

export default handleActions({
  [openHelpDialog]: state => ({ ...state, currentOpenDialog: 'help' }),
  [closeDialog]: state => ({ ...state, currentOpenDialog: null })
}, defaultState);



// WEBPACK FOOTER //
// ./src/store/dialogs/reducer.js